import(/* webpackMode: "eager" */ "/vercel/path0/apps/lms/src/app/survey/create/page.tsx");
